import React, { Component, useEffect, useState } from "react";
import { Route } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import banner_img from "../../images/banner-profile.jpg";
import case_under from "../../images/case_under.png";
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
import { scAxiosAdmin } from "../..";
import { Helmet } from "react-helmet";
import Seo from "../Seo";

const Publications = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [departmentId, setDepartmentId] = useState();
  const [loading, setLoading] = useState(false);
  const [scheduleReqData, setScheduleReqData] = useState({
    DoctorID: "",
    PreferredDate: "",
    doctorData: "",
  });
  useEffect(() => {
    const getJobOpenings = (data) => {
      try {
        setLoading(true);
        const req = scAxiosAdmin
          .request("/publications/all", {
            method: "get",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          })
          .then((data) => {
            if (data.status === 200) {
              setLoading(false);
              setSearchResults(data.data);
            }
          })
          .catch((e) => {
            setLoading(false);
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getJobOpenings();
  }, []);

  const boardmembers = [
    {
      title: "Newsletter-Issue-22,Quarter-2, 2018",
      dsc: "Our support to the community by offering Health Screening for prevention and detection of diseases saves one from the burden of disease load by early lifestyle changes & treatment. Similarly we undertake aware- ness initiatives as reflected in National Nutrition Week where visitors got educated on differ- ent need-based diets; Hand Hygiene programs were also conducted in schools. Ortho- paedic Camp at Jamalpur and Paediatric Cardiology services to child patients with heart ailments, talk about our philan- thropic endeavors. Thought- provoking articles encompass- ing cases from varied clinical specialties make this edition interesting. Diploma course in Cardiac Nursing, adds a feather ...",
      image:
        "https://uhlbd.com/administrator/uploads/images/Business%20Standard.jpg",
    },
    {
      title: "Newsletter-Issue-21,Quarter-1, 2018",
      dsc: "First edition of Newsletter in 2018 reflects some ground breaking endeavours like country’s first online pharmacy inauguration and philanthropic activities like free medical camp on Shadhinota Dibosh. Articles published are varied comprising cases of both adult & child patients displaying a combination of acute and chronic conditions. Commemoration of several International Observance Days further added colours in the engaging activities in this quarter. Participation of hospital staff at different local & international events continued as before, showing their efforts to be at par with current trends & skills. Lastly the top-notch result of students of United College of Nursing portrayed our strengthened efforts ...",
      image: "https://uhlbd.com/administrator/uploads/images/Bonik%20Barta.jpg",
    },
    {
      title: "Newsletter-Issue-20, Quarter-4, 2017",
      dsc: "The year 2017 was full of employee activation and community engagement with the aim to improve patient benefit by increasing their health awareness to help them cope better with their disease. Our participation in philanthropic endeavors like medical camp in Louhajong upazila of Munshiganj in first part of the year, two-weeks long camp in teknaf for distressed Rohingya refugees and heart camp in Jamalpur were service flag marks of this quarter. We continued dealing with complex cases, as displayed in the articles in this issue. We believe, the multidisciplinary reflection in this edition contents, depict the varied clinical strength of our ...",
      image:
        "https://uhlbd.com/backend/web/post_uploads/medium/1586774469IMG_1489-1.jpg",
    },
    {
      title:
        "United Group Signed A Project Agreement With Bangladesh Railway Under Public Private Partnership",
      dsc: "United Enterprise and Company Limited, a sister concern of United Group signed a project agreement with Bangladesh Railway ...",
      image:
        "https://uhlbd.com/backend/web/post_uploads/medium/158677382818-1.jpg",
    },
    {
      title:
        "United Hospital Inaugurated 25-bed Isolation Unit At Munshiganj To Help Covid-19 Patients",
      dsc: "As part of initiative of United Group & extended part of the United Hospital, for COVID-19 patients ...",
      image:
        "https://uhlbd.com/backend/web/post_uploads/medium/1586773514IMG_8343.jpg",
    },
  ];
  return (
    <div>
      <Seo
        title="Publications | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Publications"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" className="" style={{ backgroundColor: "#fef3e9" }}>
        <img src={banner_img} alt="banner-profile" className="w-100" />
        <section className="termscondbody pb-5">
          <div className="container">
            <div className="w-100 d-flex justify-content-center align-items-center flex-column py-4">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  marginBottom:"5px"
                  // margin: "0 auto",
                }}
              >
                <h3
                  className="text-center"
                  style={{
                    color: "#0C807D",
                    fontSize: "28px",
                    fontWeight: "500",
                    
                  }}
                >
                  PUBLICATIONS
                </h3>
                {/* <img src="/assets/images/department_under.png" alt="" /> */}
              </div>
            </div>
            {/* <h3
              className="text-center pb-5 text-center"
              style={{
                color: "#0C807D",
                fontWeight: "700",
                width: "100%",
              }}
            >
              PUBLICATIONS
            </h3> */}
            <div className="row w-100 justify-content-between g-4">
              {searchResults
                ? searchResults.map((menubars) => (
                    <div
                      className="col-12 col-sm-12 col-md-6 col-lg-6"
                      // style={{ height: "490px" }}
                    >
                      <div
                        className="card w-100 p-3 d-flex flex-column align-items-center h-100"
                        style={{ borderRadius: "10px" }}
                      >
                        <div className=" mt-3 w-100" /* key={single.id} */>
                          <div
                            className="d-flex flex-column pt-3 px-3 pb-3 gap-5"
                            style={{ backgroundClip: "#E7F2F2" }}
                          >
                            <div className="d-flex align-items-center">
                              <img
                                src={case_under}
                                alt=""
                                width={3}
                                height={70}
                              />
                              <h3
                                className="px-4 "
                                style={{
                                  fontSize: "22px",
                                  textTransform: "capitalize",
                                }}
                              >
                                {menubars.publications_title}
                              </h3>
                            </div>

                            <div className="d-flex ">
                              <div
                                className=""
                                dangerouslySetInnerHTML={{
                                  __html: menubars.publications_desc.replace(
                                    /(<p><a\s+href="([^"]+)"[^>]*>DOWNLOAD<\/a><\/p>)/,
                                    '<p style="padding:10px;"><a style="font-size: 16px; width: 118px; height: 43px; background-color: #0C807D; color: #fff; text-transform: capitalize; border: none; border-radius: 6px; font-weight: 500;padding:10px" href="$2" rel="noopener noreferrer" target="_blank">DOWNLOAD</a></p>'
                                  ),
                                }}
                              ></div>
                              {/* <p className="px-4 pt-2 text-secondary mt-3"></p> */}
                              {/* <a
                                className="px-4 pt-2 text-secondary mt-3"
                                // href={SITE_URL + "/news/" + single.Slug}
                              >
                                <button
                                  style={{
                                    fontSize: "16px",
                                    width: "118px",
                                    height: "43px",
                                    backgroundColor: "#0C807D",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                    border: "none",
                                    borderRadius: "6px",
                                    fontWeight: 500,
                                  }}
                                >
                                  Download
                                </button>
                              </a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </section>
      </div>
      <Route component={Footer} />
    </div>
  );
};
export default Publications;



// WEBPACK FOOTER //
// ./src/component/frontend/Publications.js